document.addEventListener('DOMContentLoaded', function () {
  /* =========================
     Swiper 初期化
     ========================= */
  var swiper = new Swiper('.mySwiper', {
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 16,
  grabCursor: true,
  navigation: { 
    nextEl: '.swiper-button-next', 
    prevEl: '.swiper-button-prev' 
  },
  initialSlide: 2 // ← 0始まりで数える。3枚目を表示したいなら「2」
});


  /* =========================
     モーダル開閉
     ========================= */
  // 開く
  document.querySelectorAll('.open-modal').forEach(btn => {
    btn.addEventListener('click', () => {
      document.getElementById(btn.dataset.target).classList.add('active');
    });
  });

  // 閉じる（×ボタン）
  document.querySelectorAll('.modal-close').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.modal').classList.remove('active');
    });
  });

  // 背景クリックで閉じる
  document.querySelectorAll('.modal').forEach(modal => {
    modal.addEventListener('click', e => {
      if (e.target === modal) modal.classList.remove('active');
    });
  });
});
